import { EntryLines } from './Journal';
const { Modal } = require('react-bootstrap');

// Sending moves to the server failed (other than ending the turn, which says so in its own dialog): why, and that the
// turn is as it was. "Try again" sends the same moves again (the server applies them only once: see the engine's
// Server/Authority); "Close" goes back to the turn.
// Or an earlier send had gone through after all (its answer was lost) and the moves sent since were not applied
// (Failure.earlier): what went through, as the game now shows it.
function SendFailureDialog({Failure, Sending, OnRetry, OnClose})
{
    const earlier = Failure.earlier?.filter(text => text);
    return (
        <Modal show onHide={() => !Sending && OnClose()} centered>
            <Modal.Header closeButton style={{ padding: '8px 12px' }}>
                <Modal.Title style={{ fontSize: '16px', fontWeight: 'bold' }}>
                    {Failure.earlier ? 'Your earlier moves were accepted'
                        : Failure.retry ? 'Something went wrong sending your move' : 'Your move was not accepted'}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="tta tta-left">
                {Failure.earlier ? <>
                    <div>An earlier send of yours went through, though it looked as if it had failed. What you changed after that
                        was not applied, and the game now shows what went through:</div>
                    {earlier.map((text, index) => <div key={index} className="tta-end-turn-entry" style={{ marginTop: '6px' }}><EntryLines text={text}/></div>)}
                </> : <>
                    <div>{Failure.error}{Failure.retry ? ' Please try again.' : ''}</div>
                    <div className="tta-muted" style={{ marginTop: '6px' }}>Nothing in your turn has been undone.</div>
                </>}
            </Modal.Body>
            <Modal.Footer className="tta" style={{ padding: '6px 12px' }}>
                {Sending && <span className="tta-muted">Sending…</span>}
                <button className="tta-button" disabled={Sending} onClick={OnClose}>{Failure.earlier ? 'OK' : 'Close'}</button>
                {Failure.retry &&
                    <button className="tta-button dark" disabled={Sending} onClick={OnRetry}>Try again</button>}
            </Modal.Footer>
        </Modal>
    );
}

export default SendFailureDialog;
